export default __webpack_public_path__ + "static/media/pete.2f05ee3d.png";